export default __webpack_public_path__ + "static/media/ttaBackground.b89dbba8.svg";